export const REFERRAL_TYPE = {
  APP_REFERRAL: "01",
  FRIEND_REFERRAL: "04",
  JOB_REFERRAL: "02",
};

export const REFERRAL_STATUS = [
  { code: "90", text: "hired" },
  { code: "50", text: "offered" },
  { code: "10", text: "applied" },
  { code: "00", text: "signed up" },
  { code: '-10', text: "referred" },
];
